import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import InputSimples from '../../components/Inputs/Simples';
import Button from '../../components/Button/Simples';
import AlertGeral from '../../components/Alert/Geral';
import { validateRecoveryToken, completePasswordRecovery, handleLogout } from '../../actions';
import errorHandling from '../../actions/errorHandling';

import { ReactComponent as Logo } from '../../assets/juliafloresrj-logo.svg';

class ResetarSenha extends Component {

	state = {
		senha: "",
		confirmarSenha: "",
		loading: false,
		validating: true,
		tokenValid: false,
		done: false,
		alert: null
	}

	componentDidMount(){
		const token = this.props.match.params.token;
		if(!token){
			this.setState({
				validating: false,
				tokenValid: false,
				alert: { status: false, msg: "Link inválido." }
			});
			return;
		}

		validateRecoveryToken(token)
			.then(() => this.setState({ validating: false, tokenValid: true }))
			.catch((error) => {
				const handled = errorHandling(error);
				this.setState({
					validating: false,
					tokenValid: false,
					alert: { status: false, msg: handled.message }
				});
			});
	}

	onChangeInput = (field, ev) => this.setState({ [field]: ev.target.value });

	handleSubmit = () => {
		const { senha, confirmarSenha, loading, done, tokenValid } = this.state;
		const token = this.props.match.params.token;
		if(loading || done || !tokenValid) return;

		if(!senha || senha.length < 6){
			this.setState({ alert: { status: false, msg: "A senha deve ter no mínimo 6 caracteres." } });
			return;
		}
		if(senha !== confirmarSenha){
			this.setState({ alert: { status: false, msg: "As senhas não coincidem." } });
			return;
		}

		this.setState({ loading: true, alert: null });
		completePasswordRecovery(token, senha)
			.then(() => {
				this.props.handleLogout();
				this.setState({ done: true, loading: false });
			})
			.catch((error) => {
				const handled = errorHandling(error);
				this.setState({
					loading: false,
					alert: { status: false, msg: handled.message }
				});
			});
	}

	render(){
		const { senha, confirmarSenha, loading, validating, tokenValid, done, alert } = this.state;

		return (
			<div className="Login">
				<div className="login-content">
					<div className="logo">
						<Logo />
					</div>
					<div className="data-container">
						<h2 className="auth-title">Nova senha</h2>

						{ alert ? (<AlertGeral aviso={alert} time={5000} />) : null }

						{ validating ? (
							<p className="auth-subtitle">Validando link de recuperação...</p>
						) : done ? (
							<>
								<p className="auth-subtitle">Senha redefinida com sucesso. Faça login com sua nova senha.</p>
								<div className="auth-actions auth-actions--center">
									<Button type="primary" rota="/login" label="Ir para o login" />
								</div>
							</>
						) : tokenValid ? (
							<>
								<p className="auth-subtitle">Digite e confirme sua nova senha abaixo.</p>
								<InputSimples
									label="Nova senha"
									value={senha}
									type="password"
									onChange={(ev) => this.onChangeInput("senha", ev)}
								/>
								<InputSimples
									label="Confirmar senha"
									value={confirmarSenha}
									type="password"
									onChange={(ev) => this.onChangeInput("confirmarSenha", ev)}
								/>
								<div className="auth-actions">
									<Link to="/recuperar-senha" className="auth-back-link">Solicitar novo link</Link>
									<Button
										type="primary"
										label={loading ? "Salvando..." : "Redefinir senha"}
										onClick={() => this.handleSubmit()}
									/>
								</div>
							</>
						) : (
							<div className="auth-actions auth-actions--center">
								<Button type="primary" rota="/recuperar-senha" label="Solicitar novo link" />
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default connect(null, { handleLogout })(ResetarSenha);
